import type { FC } from "react";
import { useEnableDataObjects } from "../../hooks/useEnableDataObjects";
import { WorkflowStatusOld } from "./WorkflowStatusOld";
import {
  WorkflowStatusNew,
  type WorkflowStatusNewProps
} from "./WorkflowStatusNew";

export const WorkflowStatus: FC<
  WorkflowStatusNewProps & { shouldShowNewStatus?: boolean }
> = props => {
  const { shouldShowNewStatus = false, ...rest } = props;

  const isDataObjectsEnabled = useEnableDataObjects();

  if (isDataObjectsEnabled || shouldShowNewStatus)
    return <WorkflowStatusNew {...rest} />;

  return (
    <WorkflowStatusOld
      label={rest.label}
      ellipsis={rest.ellipsis}
      customColorCode={rest.customColorCode}
      onClick={rest.onClick}
    />
  );
};
